import { Children, cloneElement, isValidElement, type ReactNode } from "react"

/** Keep each changing rich-message text node in its own replaceable DOM leaf. */
export function TranslationText({ children }: { children: ReactNode }) {
  return <>{protectText(children)}</>
}

function protectText(children: ReactNode): ReactNode {
  return Children.map(children, child => {
    if (typeof child === "string" || typeof child === "number") {
      const text = String(child)
      return <span key={text}>{text}</span>
    }
    if (isValidElement<{ children?: ReactNode }>(child)) {
      return cloneElement(child, { children: protectText(child.props.children) })
    }
    return child
  })
}
